jQuery(document).ready(function(){
    if (jQuery(window).width() <= 768) {
        jQuery("#product-sec-slider").owlCarousel({
                loop:true,
                margin:30,
                nav:true,
                dots:false,
                navText:["<span class='owl-prev'><img src='./assets/images/pro-left-arrow.svg' alt='left arrow'></span>", "<span class='owl-next'><img src='./assets/images/pro-right-arrow.svg' alt='right arrow'></span>"],
                responsive:{
                    0:{ items:1, nav:false, dots:true, },
                    576:{ items:2, nav:false, dots:true, },
                    768:{ items:3, nav:false, dots:true, },
                    1025:{ items:3 }
                }
        });
    }
});